import styled from 'styled-components';
import { Button, Form, Input } from 'antd';

export const Container = styled.div`
  background: #fff;
  border-radius: 4px;
`;

export const FormTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  margin: 20px 0;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  tbody {
    tr:nth-child(3) td {
      border-top: none;
    }
  }

  td {
    padding: 8px;
    font-size: 13px;
    vertical-align: middle;
    border-bottom: 1px solid #d9d9d9;
  }

  td:first-child {
    background-color: #f5f5f5;
    font-size: 13px;
    font-weight: 500;
    width: 20%;
    height: 45px;
    vertical-align: middle;
    border-left: none;
    border-right: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
  }

  td:last-child {
    display: flex;
    align-items: center;
    min-height: 45px;
    width: 100%;
    border-right: none;
  }

  tr:first-child td {
    border-top: 1px solid #d9d9d9;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  align-items: flex-start;

  .ant-form-item {
    flex: 1;
  }

  .ant-btn {
    margin-left: 8px;
  }
`;

export const DuplicateCheckButton = styled(Button)`
  background-color: #225f9b;
  color: white;
  border: none;
  padding: 4px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;

  text-align: center;
  vertical-align: middle;

  min-width: 60px;
  min-height: 30px;
`;

export const StyledInput = styled(Input)`
  border-radius: 4px;
  min-width: 230px;
`;

export const StyledPhoneInput = styled(Input)`
  border-radius: 4px;
`;

export const StyledInputGroup = styled.div`
  span {
    margin: 0 4px;
  }
`;

export const ErrorText = styled.p`
  color: red;
  margin-top: 10px;
`;

export const StyledStarSign = styled.span`
  color: red;
  margin: 0 2px;
  vertical-align: middle;
  font-size: 12px;
`;

export const StyledFormItem = styled(Form.Item)`
  margin-bottom: 0;

  .ant-form-item {
    margin: none;
  }

  .ant-form-item-control-input-content {
    display: flex;
    align-items: center;
  }

  &.ant-form-item {
    padding: 0;
  }

  .ant-form-item-control {
    border: none;
  }
`;
